import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import PropertyCheckbox from './components/PropertyCheckbox';
import PropertySwitch from './components/PropertySwitch';
import PropertyPicker from './components/PropertyPicker';
import BaseFeature from './BaseFeature';
import { EMERGENCY_MODE, DALI_DEXAL_SETTINGS } from '../../../../../../utils/constantFeatures';
import { linearPercentage, logarithmicPercentage } from '../../../../../../utils/percentageUtility';
import { Trans } from 'react-i18next';

class Emergency extends BaseFeature {
    isDaliFeature = true;
    constructor(props) {
        super(props);

        this.state = {
            isEnabled: this.props.properties[EMERGENCY_MODE.enable].value === "1" ? true : false
        };

        if (this.props.properties['em.nd'] && this.props.properties['em.nd'].value === "1")
            this.isDaliFeature = false;

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        const v = value;
        this.props.handleChange(propertyName, v);

        if (this.getCorrectPropertyName(propertyName) === EMERGENCY_MODE.enable) {
            this.setState({ isEnabled: v === "1" ? true : false });
        }
    }

    getPercentage(value, min, max) {
        const dimmingCurve = this.props.extraProperties[DALI_DEXAL_SETTINGS.dimmingCurve];

        if (dimmingCurve && dimmingCurve.value === '1') {
            return linearPercentage(value, min, max);
        }
        return logarithmicPercentage(value, min, max);
    }

    componentDidUpdate(prevProps) {
        if (this.props.properties !== prevProps.properties
                && this.props.properties[EMERGENCY_MODE.enable].value !== prevProps.properties[EMERGENCY_MODE.enable].value) {
            this.setState({isEnabled: this.props.properties[EMERGENCY_MODE.enable].value === "1" ? true : false });
        }
    }

    render() {

        const emEn = this.props.properties[EMERGENCY_MODE.enable];
        const emSet = this.props.properties[EMERGENCY_MODE.level];
        const emld = this.props.properties[EMERGENCY_MODE.lockDali];
        const unit = this.isDaliFeature ? this.getPercentage(emSet.value, emSet.valueMeta.min, emSet.valueMeta.max) : emSet.info.unit;

        return (
            <div>
                <Card className={this.getClassName([emEn, emSet, emld])}>
                    <div className="card-header-feature">
                        {<Trans i18nKey="Emergency_Mode" />}
                    </div>
                    <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                        <PropertySwitch
                            property={emEn}
                            title={<Trans i18nKey="DC_Mains_Emergency_Mode" />}
                            handleChange={this.handleChange} />
                        <PropertyPicker
                            disabled={!this.state.isEnabled}
                            property={emSet}
                            title={emSet.info.displayName}
                            measureUnit={unit}
                            //measureUnit={'≈ X %'}
                            min={emSet.valueMeta.min}
                            max={emSet.valueMeta.max}
                            step={1}
                            handleChange={this.handleChange} />
                        <PropertyCheckbox
                            property={emld}
                            title={emld.info.displayName}
                            handleChange={this.handleChange} />
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Emergency);
